import { WIDGET } from '@main/enums';
import { WidgetSkeletonOptions } from './widget-skeleton.types';

export const widgetSkeletonDefaultOptions: Partial<Record<WIDGET, WidgetSkeletonOptions>> = {
    [WIDGET.TOP_ADS]: { rows: 1, rowsInFullScreen: 4 },
    [WIDGET.TOP_CAMPAIGNS]: { rows: 5, rowsInFullScreen: 20 },
};
